<template>
  <div class="drag-item">
    <slot>{{item.title}}</slot>
  </div>
</template>

<script>
  import {ElementMixin} from './vue-slicksort';

  export default {
    name: "DragItem",
    mixins: [ElementMixin],
    props: {
      item: {
        type: Object,
        default() {
          return {}
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .drag-item {
    color #333
    height 42px
    z-index 102x
    line-height 42px
    background-color #fff
  }

  .drag-item + .drag-item {
    border-top 1px solid #e6e6e6
  }
</style>



// WEBPACK FOOTER //
// src/components/c_drag/DragItem.vue